export default (value: unknown): boolean => !value
